export default "__VITE_ASSET__owmbW_co__"